var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10C11 10.552 10.552 11 10 11C9.448 11 9 10.552 9 10C9 9.448 9.448 9 10 9C10.552 9 11 9.448 11 10ZM15 11H15.91C15.486 13.507 13.507 15.486 11 15.91V15C11 14.448 10.552 14 10 14C9.448 14 9 14.448 9 15V15.91C6.493 15.486 4.514 13.507 4.09 11H5C5.552 11 6 10.552 6 10C6 9.448 5.552 9 5 9H4.09C4.514 6.493 6.493 4.514 9 4.09V5C9 5.552 9.448 6 10 6C10.552 6 11 5.552 11 5V4.09C13.507 4.514 15.486 6.493 15.91 9H15C14.448 9 14 9.448 14 10C14 10.552 14.448 11 15 11ZM19 9H17.931C17.479 5.383 14.617 2.521 11 2.069V1C11 0.448 10.552 0 10 0C9.448 0 9 0.448 9 1V2.069C5.383 2.521 2.521 5.383 2.069 9H1C0.448 9 0 9.448 0 10C0 10.552 0.448 11 1 11H2.069C2.521 14.617 5.383 17.479 9 17.931V19C9 19.552 9.448 20 10 20C10.552 20 11 19.552 11 19V17.931C14.617 17.479 17.479 14.617 17.931 11H19C19.552 11 20 10.552 20 10C20 9.448 19.552 9 19 9Z",
    fill: "#F68424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.940e229fc93b2d250ad928fb2ca84f9c.svg";
export { ForwardRef as ReactComponent };